const { default: en } = require('./en');
const { default: messageConstant } = require('./message.constant');

module.exports = {
  ...en,
  ...messageConstant,
};
